import _toConsumableArray from "/codebuild/output/src145264479/src/LandingPage/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { getPath } from './get-path.js';
import { setPath } from './set-path.js';
function insertPath(path, value, index, values) {
  var currentValue = getPath(path, values);
  if (!Array.isArray(currentValue)) {
    return values;
  }
  var cloned = _toConsumableArray(currentValue);
  cloned.splice(typeof index === "number" ? index : cloned.length, 0, value);
  return setPath(path, cloned, values);
}
export { insertPath };